import './App.css';
import {useEffect, useState} from "react";
import kc from "./core/keycloakService";
import {BaseLayout} from "./core/BaseLayout";
import {Home} from "./home/Home";
import {BrowserRouter, Route, Routes} from "react-router-dom";
import {Loading} from "./loading/Loading";
import {ConfigProvider} from "antd";
import {LayerBox} from "./layerBox/layerBox";
import {Dashboard} from "./dashboard/dashboard";
import {LayerH3} from "./H3/LayerH3";

function App() {
    const [authenticated, setAuthenticated] = useState(null);
//
    //useEffect(() => {
    //    setTimeout(() => {
//
    //        if (!kc.isInitialized()) {
    //            kc.init().then((auth) => {
    //                setAuthenticated(true)
    //            })
    //        }
//
    //    }, 1000);
//
    //}, []);
//
    //if (authenticated === null) return <Loading/>
//
    //if (authenticated === false) return <h1>Not Auth</h1>

    return (
        <ConfigProvider
            theme={{
                token: {
                    // Seed Token
                    fontFamily: "PPMoriRegular, -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',\n" +
                        "    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue'",
                    colorPrimary: '#5256BE',
                    // borderRadius: 2,
                    //
                    // // Alias Token
                    // colorBgContainer: '#f6ffed',

                },
            }} 
        >
            <BrowserRouter>
                <Routes>
                    <Route path="/" element={<BaseLayout/>}>
                        <Route index element={<Home/>}/>
                        <Route path="layer/:id/:idSplit?" element={<LayerBox/>}/>
                        <Route path="h3" element={<LayerH3/>}/>
                        <Route path="dashboard" element={<Dashboard />}/>
                    </Route>
                </Routes>
            </BrowserRouter>
        </ConfigProvider>
    )
}

export default App;
